import { useEffect, useState } from "react"
import ToDoList from "./ToDoList";
import Notepad from "./Notepad";
import { Pencil } from 'lucide-react';
import { useLocation } from "react-router-dom";
import { useSingleProject, updateSingleProject } from "../../hooks/db";

import Tracks from "./Tracks";
import Comments from "./Comments";

const Project = (props) => {

    //get project id from link state
    const location = useLocation(); 
    const projectID = location.state.project_id; 
    // console.log("Project ID: ", projectID)

    //initialize project detail states
    const [project, setProject] = useState(null);
    const [tempProject, setTempProject] = useState(null);
    const [dueDate, setDueDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [daysTilDue, setDaysTilDue] = useState(null);

    const [editing, setEditing] = useState(false)

    //use custom hook to fetch project details
    let fetchedProject = useSingleProject(projectID);

    //Format fetched project fee and paid amounts to numbers
    useEffect(() => {
        if (fetchedProject && fetchedProject[0]){
            let formattedFetchedProject = fetchedProject[0];

            let fee = formattedFetchedProject.fee && typeof formattedFetchedProject.fee === 'string' ? formattedFetchedProject.fee.replaceAll("$", "") : null;
            let feeNumber = fee ? Number(fee) : null;
            formattedFetchedProject.fee = feeNumber;

            let paid = formattedFetchedProject.paid && typeof formattedFetchedProject.paid === 'string' ? formattedFetchedProject.paid.replaceAll("$", "") : null;
            let paidNumber = paid ? Number(paid) : null;
            formattedFetchedProject.paid = paidNumber;

            setProject(formattedFetchedProject)
            setTempProject(formattedFetchedProject);
        }
    },[fetchedProject])

    // Format due date and start date for local time zone display
    useEffect(() => {
        if (project) {
            var offset = new Date().getTimezoneOffset();
            var offset_ms = offset * 60000

            let due_date = new Date(Date.parse(project.due_date)+offset_ms);
            setDueDate(due_date.toLocaleDateString())

            let start_date = new Date(Date.parse(project.start_date)+offset_ms);
            setStartDate(start_date.toLocaleDateString());

            let today = Date.now()-offset_ms;
            console.log((due_date - today)/86400000)
            setDaysTilDue(Math.round((due_date - today)/86400000));
        }
    },[project])

    // Toggle editing mode and save changes if necessary
    const toggleEditing = () => {
        if (editing) {
            if (project !== tempProject) {
                console.log("Saving project changes...")
                console.log("Temp Project: ", tempProject)
                updateProject(tempProject);
            }
        }
        setEditing(!editing);
    }

    // Update project data and upload to server
    const updateProject = async (updatedProject) => {
        setProject(updatedProject)
        //validdate data format first

        try {
            await updateSingleProject(updatedProject.project_id, updatedProject);
        } catch (err) {
            console.error("Error updating project: ", err);
            return;
        } finally {
            console.log("Updating project...");
        }
    }

    if (project) {
        return (
            <div className="m-auto mt-6 px-10 max-w-[1200px] flex flex-col self-center">
                <div id="projectTitleRow" className="mb-[15px]">
                    <div className="flex">
                        {editing?
                        <div className="flex flex-col uppercase font-semibold">
                            <div className="text-xs text-[#ffee00]">Title</div>
                            <textarea
                                className="text-sm rounded-md h-[20px] pl-1 w-[100px] font-semibold mr-1"
                                defaultValue={project.title}
                                onChange={(e)=>setTempProject({ ...project, title: e.target.value })}
                            />
                        </div>
                        :
                            <>"{project.title}" -&nbsp;</>
                        }
                        <span className="text-[#ffee00] text-base uppercase font-bold">
                            {editing?
                                <div className="flex flex-col uppercase font-semibold">
                                    <div className="text-xs">Artist</div>
                                    <textarea
                                        className="text-sm rounded-md h-[20px] pl-1 w-[100px] font-semibold mr-1"
                                        defaultValue={project.client}
                                        onChange={(e)=>setTempProject({ ...project, client: e.target.value })}
                                    />
                                </div>

                            :
                                <>{project.client}</>
                            }
                        </span>
                    </div>
                    <div>
                        <button id ="editButton" onClick={()=>{toggleEditing()}}><Pencil size={18}/></button>
                    </div>
                </div>
                <div id="projectDetailsRow" className="gradientBG">
                    <div className="projectSectionHeader">
                        PROJECT DETAILS
                    </div>
                    <div id="projectDetails">
                        <form id="projectStatus">
                            <span>Status : </span>
                            <select 
                                defaultValue={project.status}
                                onChange={(e)=>updateProject({ ...project, status: e.target.value })}
                            >
                                <option value="Not Started">Not Started</option>
                                <option value="Awaiting Assets">Awaiting Assets</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Awaiting Feedback">Awaiting Feedback</option>
                                <option value="Revising">Revising</option>
                                <option value="Mastering">Mastering</option>
                                <option value="Delivering">Delivering</option>
                                <option value="Complete">Complete</option>
                            </select>
                        </form>

                        <div id="paymentDetails">
                            <div id="projectFee">
                                {editing ?
                                    <div className="flex">
                                    <div className="text-[#ffee00] uppercase font-bold">Fee:&nbsp;</div>$
                                        <input
                                            className="w-[50px] ml-1"
                                            type="number"
                                            defaultValue={project.fee}
                                            onChange={(e)=>setTempProject({ ...project, fee: e.target.value })}
                                        />
                                    </div>
                                :
                                    <><span>Fee : $</span>{project.fee}</>
                                }
                            </div>
                            <div id="projectPaid">
                                {editing ?
                                    <div className="flex">
                                        <div className="text-[#ffee00] uppercase font-bold">Paid:&nbsp;</div>$
                                        <input
                                            className="w-[50px] ml-1"
                                            type="number"
                                            defaultValue={project.paid}
                                            onChange={(e)=>setTempProject({ ...project, paid: e.target.value })}
                                        />
                                    </div>
                                :
                                    <><span>Paid : $</span>{project.paid}</>
                                }
                            </div>
                        </div>
                        <div id="projectDates">
                            <div>
                                <span>Started : </span>{startDate}
                            </div>
                            <div id="projectDueDate">
                                {editing ?
                                    <>
                                        <span className="text-[#ffee00] uppercase font-bold">Due:&nbsp;</span>
                                        <input
                                            className="w-[100px] ml-1"
                                            type="date"
                                            defaultValue={(project.due_date).slice(0, 10)}
                                            onChange={(e)=>setTempProject({ ...project, due_date: e.target.value })}
                                        />
                                    </>
                                :
                                    <>
                                        <span>Due : </span> {dueDate}
                                        {daysTilDue < 0 ?
                                            <sup className="ml-2 px-1 font-bold rounded bg-red-600">
                                                {Math.abs(daysTilDue)} days past due
                                            </sup>
                                            :
                                            daysTilDue != 0 ?
                                                <sup className="ml-2 font-bold">
                                                    in {daysTilDue} days
                                                </sup>
                                                :
                                                <sup className="ml-2 px-1 font-bold rounded bg-orange-500">
                                                    due today
                                                </sup>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div id="projectOffice" className="w-full">
                    <div className="row2 w-full flex flex-col md:grid grid-cols-2 gap-[15px]">
                        <div className="projectPageTray gradientBG">
                            <Notepad projectID={project.project_id} />
                        </div>
                        <div className="projectPageTray gradientBG min-h-[100px]">
                            <ToDoList project_id={project.project_id}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="flex justify-center items-center h-screen">
                <h1>Loading Project...</h1>
            </div>
        )
    }
}

export default Project